(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["know-your-flow"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const banner = document.getElementById('fullHeightBanner');

    function setBannerHeight() {
      const vh = window.innerHeight * 0.01;
      banner.style.height = `${vh * 100 - 100}px`;
    }

    // Set the initial height
    setBannerHeight();

    // Update banner height on resize
    window.addEventListener('resize', setBannerHeight);
  });
  document.addEventListener('DOMContentLoaded', function () {
    const startButton = document.getElementById('StartButton');
    const steps = document.querySelectorAll('.flow-step');
    const stepIndicators = document.querySelectorAll('.step-indicator .step');
    const stepIndicatorDiv = document.querySelector('.step-indicator');
    const periodDaysInput = document.getElementById('PeriodDaysInput'); // Initialize PeriodDaysInput
    const padsInputDayContainer = document.getElementById('PadsInputDay'); // Initialize PadsInputDay container
    let currentStep = 0;

    // Function to set a cookie
    function setCookie(name, value, hours) {
      let date = new Date();
      date.setTime(date.getTime() + hours * 60 * 60 * 1000); // Set expiration to 1 hour from now
      document.cookie = `${name}=${value}; expires=${date.toUTCString()}; path=/`;
    }

    // Function to get a cookie value
    function getCookie(name) {
      const nameEQ = name + '=';
      const cookies = document.cookie.split(';');
      for (let i = 0; i < cookies.length; i++) {
        let cookie = cookies[i];
        while (cookie.charAt(0) === ' ') cookie = cookie.substring(1);

        if (cookie.indexOf(nameEQ) === 0) return cookie.substring(nameEQ.length);
      }
      return null;
    }

    // Function to save input data to cookies
    function saveData() {
      const inputs = steps[currentStep].querySelectorAll('input, select');
      inputs.forEach((input) => {
        if (input.type === 'radio' && !input.checked) return;
        setCookie(input.id, input.value, 1); // Save input value to cookie for 1 day
      });
    }

    // Function to load input data from cookies
    function loadData() {
      steps.forEach((step) => {
        const inputs = step.querySelectorAll('input, select');
        inputs.forEach((input) => {
          const cookieValue = getCookie(input.id);
          if (cookieValue) {
            if (input.type === 'radio') {
              input.checked = input.value === cookieValue;
            } else {
              input.value = cookieValue;
            }
          }
        });
      });
    }

    // Update PadsInputDay based on PeriodDaysInput selection
    periodDaysInput.addEventListener('change', function () {
      const selectedDays = parseInt(periodDaysInput.value, 10) || 0;

      // Clear existing days in PadsInputDay container
      padsInputDayContainer.innerHTML = '';

      // Loop to create pads inputs up to selected days
      for (let i = 1; i <= selectedDays; i++) {
        const padDiv = document.createElement('div');
        padDiv.classList.add('pad-days');
        padDiv.innerHTML = `
                <span>Day ${i}</span> 
                <select class="pads" id="PadsInputDay${i}" required>
                    <option value="light">1 Pad</option>
                    <option value="medium">2 Pads</option>
                    <option value="medium">3 Pads</option>
                    <option value="heavy">4 Pads</option>
                    <option value="heavy">5 Pads</option>
                    <option value="super heavy">6 Pads</option>
                    <option value="super heavy">7 Pads+</option>
                </select>
                <span class="error-message"></span>
            `;
        padsInputDayContainer.appendChild(padDiv);
      }
      // Save the number of days selected to a cookie
      setCookie('PadsInputDays', selectedDays, 1);
    });

    // Initialize PadsInputDay based on saved cookie
    const savedDays = parseInt(getCookie('PadsInputDays'), 10) || 0;
    if (savedDays) {
      periodDaysInput.value = savedDays;
      periodDaysInput.dispatchEvent(new Event('change'));
    }

    function showStep(index) {
      steps.forEach((step, i) => {
        if (i === index) {
          step.classList.add('active');
          if (stepIndicators[i]) {
            stepIndicators[i].classList.add('active', 'completed');
          }
        } else {
          step.classList.remove('active');
          if (stepIndicators[i]) {
            stepIndicators[i].classList.remove('active');
          }
        }
      });

      // Hide step-indicator if it's the last step
      stepIndicatorDiv.style.display = index === steps.length - 1 ? 'none' : 'flex';
    }

    function clearError(input) {
      const errorSpan = input.nextElementSibling;
      if (errorSpan && errorSpan.classList.contains('error-message')) {
        errorSpan.textContent = '';
        errorSpan.style.display = 'none'; // Hide the error message
      }
      input.classList.remove('invalid');

      // Remove error-arrow class from the parent div
      const field = input.closest('.period-cycle-field, .size-title-field', 'pad-days');
      if (field) {
        field.classList.remove('error-arrow');
      }
    }

    function showError(input, message) {
      let errorSpan = input.nextElementSibling;
      if (!errorSpan || !errorSpan.classList.contains('error-message')) {
        errorSpan = document.createElement('span');
        errorSpan.classList.add('error-message');
        input.parentNode.insertBefore(errorSpan, input.nextSibling);
      }
      errorSpan.textContent = message;
      errorSpan.style.display = 'block'; // Show the error message
      errorSpan.style.color = 'red';
      errorSpan.style.fontSize = '12px';
      errorSpan.style.marginTop = '15px';
      input.classList.add('invalid');

      const field = input.closest('.period-cycle-field, .size-title-field', 'pad-days');
      if (field) {
        field.classList.add('error-arrow');
      }
    }

    function validateInput(input) {
      clearError(input);

      // Validate Name Input
      if (input.id === 'Name' && input.value.trim() === '') {
        showError(input, 'Please enter your name.');
        return false;
      }

      // Validate Size Input
      if (input.id === 'SizeInput' && input.value.trim() === '') {
        showError(input, 'Please select your size.');
        return false;
      }

      // Validate Email Input
      if (input.id === 'EmailInput') {
        const email = input.value.trim();
        if (email === '') {
          showError(input, 'Please enter your email address.');
          return false;
        } else if (!/^\S+@\S+\.\S+$/.test(email)) {
          showError(input, 'Please enter a valid email address.');
          return false;
        }
      }

      // Validate Mobile Number Input
      if (input.id === 'MobileNumberInput') {
        const phoneNumber = input.value.trim();
        const phonePattern = /^[6-9]\d{9}$/; // Ensure starts with 6-9 and exactly 10 digits

        if (phoneNumber === '') {
          showError(input, 'Please enter your phone number.');
          return false;
        } else if (!/^[6-9]/.test(phoneNumber)) {
          showError(input, 'Number should start with 6 to 9.');
          return false;
        } else if (!/^\d+$/.test(phoneNumber)) {
          showError(input, 'Phone number should not contain any characters or special symbols.');
          return false;
        } else if (!phonePattern.test(phoneNumber)) {
          showError(input, 'Phone number should be exactly 10 digits.');
          return false;
        }
      }

      // General Validation for required inputs
      if (!input.value.trim()) {
        showError(input, 'This field is required.');
        return false;
      }

      return true;
    }

    function validateStep(step) {
      const inputs = step.querySelectorAll('input[required], select[required]');
      let isValid = true;

      inputs.forEach((input) => {
        // Clear error on input or change
        input.addEventListener('input', () => clearError(input));
        input.addEventListener('change', () => clearError(input));

        if (!validateInput(input)) {
          isValid = false;
        }
      });

      return isValid;
    }

    function nextStep() {
      if (validateStep(steps[currentStep])) {
        if (document.getElementById('PeriodDaysInput') && currentStep == 0) {
          document.getElementById('PeriodDaysInput').selectedIndex = 0; // Reset to default option
        }
        saveData(); // Save data before moving to the next step
        if (currentStep < steps.length - 1) {
          currentStep++;
          showStep(currentStep);
        } else {
          //window.location.href = 'https://mahina.co/collections/know-your-flow?view=flow';
        }
      }
    }

    function prevStep() {
      if (currentStep > 0) {
        stepIndicators[currentStep].classList.remove('active', 'completed');
        currentStep--;
        showStep(currentStep);
      }
    }

    startButton.addEventListener('click', function () {
      document.querySelector('.starting-step').style.display = 'none';
      document.querySelector('.flow-steps').style.display = 'block';
      showStep(currentStep);
    });

    steps.forEach((step) => {
      const nextButton = step.querySelector('button.primary--button');
      if (nextButton) {
        nextButton.addEventListener('click', nextStep);
      }
      const backButton = step.querySelector('button.back-button');
      if (backButton) {
        backButton.addEventListener('click', prevStep);
      }
    });

    loadData(); // Load data from cookies when the form is initialized
    showStep(currentStep);
  });

  document.getElementById('Step--step-3').addEventListener('click', function (event) {
    event.preventDefault();

    // Get the selected radio button value
    const selectedProduct = document.querySelector('input[name="fav_product"]:checked').value;

    // Get all the select elements for day quantities (Day 1 to Day 7)
    const selectElements = document.querySelectorAll('.quantity-period-product-field select');

    // Function to dynamically generate text for 7 options based on the product type
    function generateOptionTexts(product) {
      const optionTexts = [];
      for (let i = 1; i <= 7; i++) {
        if (product === 'Tampons') {
          optionTexts.push(`${i} Tampon${i > 1 ? 's' : ''}${i == 7 ? '+' : ''}`);
        } else if (product === 'Pads') {
          optionTexts.push(`${i} Pad${i > 1 ? 's' : ''}${i == 7 ? '+' : ''}`);
        } else if (product === 'Cups') {
          optionTexts.push(`${i} Cup${i > 1 ? 's' : ''}${i == 7 ? '+' : ''}`);
        }
      }
      return optionTexts;
    }

    // Get the correct option texts for the selected product
    const optionTexts = generateOptionTexts(selectedProduct);

    // Update all 7 select boxes with the same product-specific texts, but retain the option values
    selectElements.forEach((select) => {
      // Get the existing option values and replace their text content
      const options = select.querySelectorAll('option');
      options.forEach((option, index) => {
        if (index < optionTexts.length) {
          // Only update the text, not the value
          option.textContent = optionTexts[index];
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-account"]) return;
  try {
    
  function showSection(sectionId) {
    // Hide all content sections
    if(document.querySelector('.content-section')){
      document.querySelectorAll('.content-section').forEach((section) => {
        section.classList.remove('active');
      });
    }

    // Show the selected content section
    const activeSection = document.getElementById(sectionId);
    if (activeSection) {
      activeSection.classList.add('active');
    }
    if (activeSection.id == 'dashboard') {
      document.querySelectorAll('.sidebar ul li').forEach((li) => {
        li.classList.remove('active');
      });
      qs(`#view-${sectionId}`).classList.add('active');
      qs('.account-items').classList.add('active');
      if(qs('.account-items .pdp_sec12 .owl-carousel-account')){
        $(".account-items .pdp_sec12 .owl-carousel-account").slick({
          infinite: false,
          slidesToShow: 3.7,
          slidesToScroll: 1,
          dots: false,
          gap: 20,
          margin: 30,
          prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 15 28" height="28" width="15"><path fill="black" d="M14.6629 25.8374C14.755 25.9233 14.8289 26.0268 14.8801 26.1418C14.9314 26.2568 14.9589 26.3809 14.9611 26.5068C14.9634 26.6327 14.9402 26.7577 14.8931 26.8744C14.8459 26.9912 14.7757 27.0972 14.6867 27.1862C14.5977 27.2753 14.4916 27.3454 14.3749 27.3926C14.2582 27.4397 14.1331 27.4629 14.0072 27.4607C13.8814 27.4584 13.7572 27.4309 13.6422 27.3797C13.5272 27.3284 13.4237 27.2545 13.3379 27.1624L0.837896 14.6624C0.662333 14.4866 0.563721 14.2484 0.563721 13.9999C0.563721 13.7515 0.662333 13.5132 0.837896 13.3374L13.3379 0.83743C13.5156 0.67183 13.7507 0.581676 13.9935 0.585961C14.2364 0.590247 14.4682 0.688636 14.6399 0.860403C14.8117 1.03217 14.9101 1.2639 14.9144 1.50678C14.9187 1.74965 14.8285 1.98471 14.6629 2.16243L2.82696 13.9999L14.6629 25.8374Z"></path></svg></button>',
          nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 15 28" height="28" width="15"><path fill="black" d="M14.6629 25.8374C14.755 25.9233 14.8289 26.0268 14.8801 26.1418C14.9314 26.2568 14.9589 26.3809 14.9611 26.5068C14.9634 26.6327 14.9402 26.7577 14.8931 26.8744C14.8459 26.9912 14.7757 27.0972 14.6867 27.1862C14.5977 27.2753 14.4916 27.3454 14.3749 27.3926C14.2582 27.4397 14.1331 27.4629 14.0072 27.4607C13.8814 27.4584 13.7572 27.4309 13.6422 27.3797C13.5272 27.3284 13.4237 27.2545 13.3379 27.1624L0.837896 14.6624C0.662333 14.4866 0.563721 14.2484 0.563721 13.9999C0.563721 13.7515 0.662333 13.5132 0.837896 13.3374L13.3379 0.83743C13.5156 0.67183 13.7507 0.581676 13.9935 0.585961C14.2364 0.590247 14.4682 0.688636 14.6399 0.860403C14.8117 1.03217 14.9101 1.2639 14.9144 1.50678C14.9187 1.74965 14.8285 1.98471 14.6629 2.16243L2.82696 13.9999L14.6629 25.8374Z"></path></svg></button>',
          responsive: [
              {
                  breakpoint: 0,
                  settings: {
                      slidesToShow: 1.2,
                      slidesToScroll: 1,
                      dots: false,
                  }
              },
              {
                  breakpoint: 768,
                  settings: {
                      slidesToShow: 1.2,
                      slidesToScroll: 1,
                      dots: false,
                  }
              },
              {
                  breakpoint: 990,
                  settings: {
                      slidesToShow: 3.7,
                      slidesToScroll: 1,
                      dots: true,
                  }
              }
          ]
      });
    }
    } else {
      qs('.account-items').classList.remove('active');
    }

    // Remove 'active' class from all sidebar list items
    if(document.querySelector('.sidebar ul li')){
      document.querySelectorAll('.sidebar ul li').forEach((li) => {
        li.classList.remove('active');
      });
    }

    // Add 'active' class to the clicked sidebar item
    const activeSidebarItem = document.querySelector(`#view-${sectionId}`);
    if (activeSidebarItem) {
      activeSidebarItem.classList.add('active');
    }
  }

  // Add event listeners for all sidebar items
  document.addEventListener('DOMContentLoaded', () => {
    var referContainer = document.querySelector('.template-customers-account .container.fully-spaced-row--small');
    document.getElementById('view-dashboard').addEventListener('click', () => showSection('dashboard'));
    document.getElementById('view-profile').addEventListener('click', () => showSection('profile'));
    document.getElementById('view-orders').addEventListener('click', () => showSection('orders'));
    document.getElementById('view-loyalty').addEventListener('click', () => showSection('loyalty'));
    if(document.getElementById('view-refer')){
      document.getElementById('view-refer').addEventListener('click', () => {
        showSection('refer');
        referContainer.classList.add('account-refer');
      });
    }
    if(document.getElementById('view-address')){
      document.getElementById('view-address').addEventListener('click', () => showSection('address'));
    }

    // Check URL hash on page load
    const hash = window.location.hash.substring(1); // Remove the '#' symbol
    if (hash) {
      showSection(hash);
    } else {
      showSection('dashboard'); // Default active section
    }

    // Listen for hash changes
    window.addEventListener('hashchange', () => {
      const newHash = window.location.hash.substring(1);
      if (newHash) {
        showSection(newHash);
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-addresses"]) return;
  try {
    
  function showSection(sectionId) {
    // Hide all content sections
    document.querySelectorAll('.content-section').forEach((section) => {
      section.classList.remove('active');
    });

    // Show the selected content section
    const activeSection = document.getElementById(sectionId);
    if (activeSection) {
      activeSection.classList.add('active');
    }
    if (activeSection.id == 'dashboard') {
      document.querySelectorAll('.sidebar ul li').forEach((li) => {
        li.classList.remove('active');
      });
      qs(`#view-${sectionId}`).classList.add('active');
      qs('.account-items').classList.add('active');
      $('.account-items .pdp_sec12 .owl-carousel-account').slick({
        infinite: false,
        slidesToShow: 3.7,
        slidesToScroll: 1,
        dots: false,
        gap: 20,
        arrows: true,
        margin: 30,
        prevArrow:
            '<button type="button" class="custom-arrow-left slick-prev"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 15 28" height="28" width="15"><path fill="black" d="M14.6629 25.8374C14.755 25.9233 14.8289 26.0268 14.8801 26.1418C14.9314 26.2568 14.9589 26.3809 14.9611 26.5068C14.9634 26.6327 14.9402 26.7577 14.8931 26.8744C14.8459 26.9912 14.7757 27.0972 14.6867 27.1862C14.5977 27.2753 14.4916 27.3454 14.3749 27.3926C14.2582 27.4397 14.1331 27.4629 14.0072 27.4607C13.8814 27.4584 13.7572 27.4309 13.6422 27.3797C13.5272 27.3284 13.4237 27.2545 13.3379 27.1624L0.837896 14.6624C0.662333 14.4866 0.563721 14.2484 0.563721 13.9999C0.563721 13.7515 0.662333 13.5132 0.837896 13.3374L13.3379 0.83743C13.5156 0.67183 13.7507 0.581676 13.9935 0.585961C14.2364 0.590247 14.4682 0.688636 14.6399 0.860403C14.8117 1.03217 14.9101 1.2639 14.9144 1.50678C14.9187 1.74965 14.8285 1.98471 14.6629 2.16243L2.82696 13.9999L14.6629 25.8374Z"></path></svg></button>',
        nextArrow:
            '<button type="button" class="custom-arrow-right slick-next"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 15 28" height="28" width="15"><path fill="black" d="M14.6629 25.8374C14.755 25.9233 14.8289 26.0268 14.8801 26.1418C14.9314 26.2568 14.9589 26.3809 14.9611 26.5068C14.9634 26.6327 14.9402 26.7577 14.8931 26.8744C14.8459 26.9912 14.7757 27.0972 14.6867 27.1862C14.5977 27.2753 14.4916 27.3454 14.3749 27.3926C14.2582 27.4397 14.1331 27.4629 14.0072 27.4607C13.8814 27.4584 13.7572 27.4309 13.6422 27.3797C13.5272 27.3284 13.4237 27.2545 13.3379 27.1624L0.837896 14.6624C0.662333 14.4866 0.563721 14.2484 0.563721 13.9999C0.563721 13.7515 0.662333 13.5132 0.837896 13.3374L13.3379 0.83743C13.5156 0.67183 13.7507 0.581676 13.9935 0.585961C14.2364 0.590247 14.4682 0.688636 14.6399 0.860403C14.8117 1.03217 14.9101 1.2639 14.9144 1.50678C14.9187 1.74965 14.8285 1.98471 14.6629 2.16243L2.82696 13.9999L14.6629 25.8374Z"></path></svg></button>',
        responsive: [
          {
            breakpoint: 0,
            settings: {
              slidesToShow: 1.2,
              slidesToScroll: 1,
              dots: false,
              arrows: true,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1.2,
              slidesToScroll: 1,
              dots: false,
              arrows: true,
            },
          },
          {
            breakpoint: 990,
            settings: {
              slidesToShow: 3.7,
              slidesToScroll: 1,
              dots: true,
              arrows: true,
            },
          },
        ],
      });
    } else {
      qs('.account-items').classList.remove('active');
    }

    // Remove 'active' class from all sidebar list items
    document.querySelectorAll('.sidebar ul li').forEach((li) => {
      li.classList.remove('active');
    });

    // Add 'active' class to the clicked sidebar item
    const activeSidebarItem = document.querySelector(`#view-${sectionId}`);
    if (activeSidebarItem) {
      activeSidebarItem.classList.add('active');
    }
  }

  // Add event listeners for all sidebar items
  document.addEventListener('DOMContentLoaded', () => {
    var referContainer = document.querySelector('.template-customers-account .container.fully-spaced-row--small');
    document.getElementById('view-dashboard').addEventListener('click', () => showSection('dashboard'));
    document.getElementById('view-profile').addEventListener('click', () => showSection('profile'));
    document.getElementById('view-orders').addEventListener('click', () => showSection('orders'));
    document.getElementById('view-loyalty').addEventListener('click', () => showSection('loyalty'));
    document.getElementById('view-refer').addEventListener('click', () => {
      showSection('refer');
      referContainer.classList.add('account-refer');
    });
    document.getElementById('view-address').addEventListener('click', () => showSection('address'));

    // Check URL hash on page load
    const hash = window.location.hash.substring(1); // Remove the '#' symbol
    if (hash) {
      showSection(hash);
    } else {
      showSection('dashboard'); // Default active section
    }

    // Listen for hash changes
    window.addEventListener('hashchange', () => {
      const newHash = window.location.hash.substring(1);
      if (newHash) {
        showSection(newHash);
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      theme.ProductBlockManager.loadImages(productRecommendationsSection);
      theme.initAnimateOnScroll();
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
